import { graphql } from '@api/generated';
import { getClient } from '../../../api/client';
import { CombinedGraphQLErrors } from '@apollo/client';

const updateWorkflowNameSettingMutation = graphql(`
  mutation updateWorkflowNameSettingMutation(
    $contactCenterSettings: ContactCenterSettingsInput!
  ) {
    updateContactCenterSettings(contactCenterSettings: $contactCenterSettings) {
      showWorkflowNameOnInboundCalls {
        isEnabled
      }
    }
  }
`);

async function updateWorkflowNameSetting(isEnabled: boolean): Promise<boolean> {
  const { data, error } = await getClient().mutate({
    mutation: updateWorkflowNameSettingMutation,
    variables: {
      contactCenterSettings: {
        showWorkflowNameOnInboundCalls: {
          isEnabled,
        },
      },
    },
  });

  if (CombinedGraphQLErrors.is(error) && error.errors.length > 0) {
    throw new Error(error.errors[0].message);
  }

  return (
    data?.updateContactCenterSettings?.showWorkflowNameOnInboundCalls
      ?.isEnabled ?? isEnabled
  );
}

export default updateWorkflowNameSetting;
